module.exports = "https://coursera_assets.s3.amazonaws.com/images/9933d64a384518a9b6b2fd993129d562.png";